import { useEditorPlugin } from '@udecode/plate/react';
import {
    useVirtualFloating,
    type UseVirtualFloatingOptions,
} from '@udecode/plate-floating';

import { CitationPlugin } from '../../CitationPlugin';

export const useVirtualFloatingCitation = ({
    editorId,
    ...floatingOptions
}: { editorId: string } & UseVirtualFloatingOptions) => {
    const { setOption } = useEditorPlugin(CitationPlugin);

    return useVirtualFloating({
        onOpenChange: (open) => setOption('openEditorId', open ? editorId : null),
        ...floatingOptions,
    });
};
